// utils/getRedirectPathFromPermissions.ts
import { NAVIGATION_URLS } from "../../shared/utils/urls";

export const getRedirectPathFromPermissions = (_permissions: string[]): string => {
    return NAVIGATION_URLS.DASHBOARD;
};
